import { render, staticRenderFns } from "./SearchWidgets.vue?vue&type=template&id=4ef27dcd"
import script from "./SearchWidgets.vue?vue&type=script&lang=js"
export * from "./SearchWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports